/** @jsx h */
import { h, Component } from 'preact'

import CollaborationBack from './CollaborationBack'
import CollaborationCard from './CollaborationCard'
import CollaborationFront from './CollaborationFront'
import FullCard from './FullCard'
import Modal from '../Modal'

class CollaborationCardPJ extends Component {
  constructor (props) {
    super(props)

    this.state = { isOpen: false }
    this.handleToggleModal = this.handleToggleModal.bind(this)
  }

  handleToggleModal () {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }))
  }

  render () {
    const action = (
      <button
        class='ClaimCard-action'
        onClick={this.handleToggleModal}
        type='button'
      >
        See the proof
      </button>
    )
    const { isOpen } = this.state

    return (
      <div>
        <CollaborationCard {...this.props} shadow='shadow' action={action} />
        <Modal show={isOpen} onClose={this.handleToggleModal}>
          <FullCard
            front={CollaborationFront}
            back={CollaborationBack}
            content={this.props}
            inJourney
          />
        </Modal>
      </div>
    )
  }
}

export default CollaborationCardPJ
